<template>
  <v-card flat class="px-3">
    <v-col
      @click="beforeLeave"
      cols="12"
      class="body-bold-smaller btnTextType1--text py-0 backBtn"
    >
      <v-icon size="12" class="backIcon">mdi-arrow-left</v-icon>
      <a type="primary" class="body-bold-smaller brand-60-base--text"
        >{{ $t('message.actions.return') }}
      </a>
    </v-col>
    <div v-if="!loading">
      <v-col class="pt-1 py-0">
        <span class="body-bold-medium">{{
          $t('message.pandaVideoAffiliate')
        }}</span>
      </v-col>

      <v-col
        cols="12"
        class="py-0"
        :class="{ 'pb-3': pandaBranding, 'pb-5': !pandaBranding }"
      >
        <span class="body-regular-smaller neutral-40-light--text">
          {{ $t('message.affiliateVideoPage.description') }}
          <a target="_blank" type="secondary" :href="pandaLogoArticle">
            <span>
              {{ $t('message.actions.knowMore') }}
            </span>
            <v-icon size="12">mdi-open-in-new</v-icon>
          </a>
        </span>
      </v-col>
      <v-col v-if="!pandaBranding" cols="12" class="py-0 px-1 pb-4">
        <base-alert
          class="base-alert"
          type="informative"
          :title="
            $t('message.pages.video.controlsPage.logo.disabled.logoAlertTitle')
          "
          :description="
            $t(
              'message.pages.video.controlsPage.logo.disabled.logoAlertDescription'
            )
          "
        ></base-alert>
      </v-col>
      <v-row no-gutters class="py-0 px-3">
        <v-col cols="12" class="mt-0">
          <v-row v-if="hasEditVideoPerm">
            <v-col>
              <h3 class="body-bold-base py-2 pb-1">
                {{ $t('message.affiliateVideoPage.actionTitle') }}
              </h3>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="mt-0 mb-4">
          <v-row v-if="hasEditVideoPerm" style="align-items: center">
            <v-col class="d-flex justify-space-between">
              <span class="body-regular-small py-2">
                {{ $t('message.affiliateVideoPage.action') }}
              </span>
              <div>
                <v-tag
                  v-if="pandaBranding"
                  type="success"
                  style="pointer-events: none"
                  >{{ $t('message.affiliateVideoPage.enabled') }}</v-tag
                >
                <v-tag v-else type="disabled">{{
                  $t('message.deactivated')
                }}</v-tag>
                <base-btn
                  icon
                  size="small"
                  type="tertiary"
                  class="ml-4 mr-5"
                  @click="redirectPlayerPageLogo"
                  >{{ $t('message.affiliateVideoPage.manage')
                  }}<v-icon class="body-bold-smaller pl-2" size="20"
                    >mdi-open-in-new</v-icon
                  ></base-btn
                >
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <span
        v-if="internalError"
        class="red--text caption align-text ml-2 mt-2 d-block"
      >
        <v-icon color="red" size="16" class="mt-n1"> mdi-alert-circle </v-icon>
        {{ $t('message.pages.video.errors.updateMarketing') }}
      </span>
    </div>
    <template v-else>
      <v-container>
        <v-row class="d-flex">
          <v-col cols="12">
            <v-skeleton-loader
              class="border loader-width"
              type="chip"
            ></v-skeleton-loader>
          </v-col>
          <v-col cols="12">
            <v-skeleton-loader
              class="border loader-width"
              type="image"
            ></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </v-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import i18n from '@/translations/lang'
import _ from 'lodash'
import BaseAlert from '@/components/BaseAlert.vue'
import playerApi from '@/services/playerApi'
export default {
  name: 'VideoPlayerAffiliate',
  components: {
    BaseAlert,
  },
  props: {
    handleBack: {
      type: Function,
      required: true,
    },
    liveVideoId: {
      required: false,
    },
    hasEdit: {
      type: Array,
    },
  },
  data: () => ({
    videoId: '',
    loadingButtonSave: false,
    loading: false,
    profileId: null,
    profileConfig: {},
    initialConfig: {},
    pandaBranding: false,
    refCode: '',
    rules: {
      maxLength: (v) =>
        (v && v.length <= 30) ||
        v.length === 0 ||
        i18n.t('message.maximumLengthConfigs'),
      minLength: (v) =>
        (v && v.length >= 3) ||
        v.length === 0 ||
        i18n.t('message.minimumLength'),
    },
    withoutChanges: true,
  }),
  async mounted() {
    this.loading = true
    this.videoId = this.liveVideoId ? this.liveVideoId : this.$route.params.id
    this.profileId = this.$store.state.video.video.config?.profile
    const ret = await playerApi.getPlayer()
    this.pandaBranding = ret.data?.config?.pandaBranding
    this.refCode = this.$store.state.video.profile?.vsl.refCode
    this.initialConfig['pandaBranding'] = _.cloneDeep(this.pandaBranding)
    this.initialConfig['refCode'] = _.cloneDeep(this.refCode)
    this.hasEdit.push(this.checkChanges)
    this.$root.$on('discardChanges', () => {
      this.handleUndoChanges()
      this.handleBack()
    })
    this.loading = false
  },
  watch: {
    '$store.state.video.profile': {
      handler() {
        this.withoutChanges = this.checkChanges()
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      profile: (state) => state.video.profile,
      video: (state) => state.video.video,
      profile_id: (state) => state.video.profile_id,
      internalError: (state) => state.video.internalError,
      hasEditVideoPerm() {
        return (
          this.$store.state.user.userPermissions?.includes('put-video') ?? false
        )
      },
    }),
    pandaLogoArticle() {
      if (this.locale === 'en') {
        return 'https://help.pandavideo.com/en-us/article/panda-video-logo-on-the-player-1jln9d4/'
      }
      if (this.locale === 'es') {
        return 'https://help.pandavideo.com/es/article/logo-de-panda-video-en-el-player-kcp6og/'
      }
      return 'https://help.pandavideo.com/pt-br/article/logo-da-panda-video-no-player-ks561x/'
    },
    locale() {
      return this.$i18next.resolvedLanguage
    },
  },
  methods: {
    ...mapActions('video', [
      'updateProfile',

      'createProfile',

      'setProfileToVideos',
    ]),
    ...mapMutations('video', [
      'UPDATE_VIDEO_PROFILE',
      'UPDATE_VIDEO_PROFILE_ID',
      'UPDATE_STATUS_ERROR',
    ]),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    async handleUpdateMarketing() {
      this.loadingButtonSave = true
      const controls = this.$store.state.video.profile.controls
      const colors = this.$store.state.video.profile.colors
      const vsl = this.$store.state.video.profile.vsl
      if (
        (this.refCode.length < 3 && this.refCode.length !== 0) ||
        this.refCode.length > 30
      ) {
        this.loadingButtonSave = false
        return
      }
      try {
        if (!this.video.config.profile) {
          await this.createProfile(this.videoId)
          this.video.config.profile = this.profile_id
          this.profileId = this.profile_id
          await this.setProfileToVideos([this.profileId, this.videoId])
        }
        await this.updateProfile([
          this.profileId,
          {
            controls: controls,
            colors: colors,
            vsl: vsl,
            pandaBranding: this.pandaBranding,
          },
        ])
        this.internalError
          ? ''
          : ((this.initialConfig.refCode = _.cloneDeep(this.refCode)),
            (this.initialConfig.pandaBranding = _.cloneDeep(
              this.pandaBranding
            )),
            this.handleSnackbar(this.$t('message.pages.video.changesSaved')),
            (this.withoutChanges = true))
        this.loadingButtonSave = false
      } catch (e) {
        console.error(e)
        this.loadingButtonSave = false
      }
      this.$root.$emit('updateEmbedPreviewChange')
    },
    async changePlayer() {
      this.profile.vsl['refCode'] = this.refCode
      this.profile.vsl['pandaBranding'] = this.pandaBranding
      this.UPDATE_STATUS_ERROR(false)
      this.UPDATE_VIDEO_PROFILE(this.profile)
      this.$root.$emit('updateEmbedPreviewChange')
    },
    async handleUndoChanges() {
      this.refCode = _.cloneDeep(this.initialConfig.refCode)
      this.pandaBranding = _.cloneDeep(this.initialConfig.pandaBranding)
      this.changePlayer()
    },
    checkChanges() {
      let verification1 = _.isEqual(
        this.profile.vsl.refCode,
        this.initialConfig.refCode
      )
      let verification3 = _.isEqual(
        this.profile.vsl.pandaBranding,
        this.initialConfig.pandaBranding
      )
      return verification1 && verification3
    },
    beforeLeave() {
      this.UPDATE_STATUS_ERROR(false)
      this.handleBack()
    },
    handleSnackbar(item) {
      if (!item) {
        item = i18n.t('message.changesSaved')
      }
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: item,
      })
    },
    redirectPlayerPageLogo() {
      this.$router.push({ name: 'Player', query: { tab: 3 } })
    },
  },
}
</script>

<style lang="scss">
.v-chip__logo-enabled {
  background: varFigma(brand-90) !important;
}
.v-chip__logo-disabled {
  background: varFigma(neutral-95-lightest) !important;
}
</style>
<style lang="scss" scoped>
::v-deep .base-alert .alert-content .alert-title {
  font-family: Rubik;
  font-size: 12px !important;
  font-style: normal;
  font-weight: 500 !important;
  line-height: 150% !important;
}
</style>
